import React, { useLayoutEffect, useState } from "react";
import { ListContainer } from "./style";
import ProductBox from "components/productBox";
import EmptyState from "components/emptyState";
const cashItems = [];
const installmentItems = [];
const List = ({ items, select, showPic }) => {
  const [type, setType] = useState("");
  useLayoutEffect(() => {
    items.forEach((item) => {
      if (item.type === "cash") {
        cashItems.push(item);
      } else {
        installmentItems.push(item);
      }
    });
    if (cashItems.length > 0 && installmentItems.length > 0) {
      setType("cash");
    }
  }, [items]);
  const typeSwitch = () => {
    if (cashItems.length > 0 && installmentItems.length > 0) {
      return (
        <div className="type-selector">
          <div
            className={`item ${type === "cash" ? "active" : ""}`}
            onClick={() => setType("cash")}
          >
            نقد
          </div>
          <div
            className={`item ${type === "installment" ? "active" : ""}`}
            onClick={() => setType("installment")}
          >
            اقساط
          </div>
        </div>
      );
    }
  };
  const viewItems = () => {
    if (type === "") {
      return items.map((item) => (
        <ProductBox
          key={item.id}
          showPic={showPic}
          item={item}
          select={select}
        />
      ));
    } else {
      return items.map((item) => {
        if (item.type === type) {
          return (
            <ProductBox
              key={item.id}
              showPic={showPic}
              item={item}
              select={select}
            />
          );
        }
      });
    }
  };
  if (!items) return <EmptyState message="ارتباط با سرور با مشکل روبه‌رو شد" />;
  return (
    <ListContainer>
      <h5>لیست خودرو های موجود</h5>
      {items.length === 0 ? (
        <EmptyState message="در حال حاضر بخش نامه ای برای فروش وجود ندارد" />
      ) : (
        <>
          {typeSwitch()}
          {viewItems()}
        </>
      )}
    </ListContainer>
  );
};
export default List;